import React from "react";
import { useFormContext } from "react-hook-form";

import { testTypeOptions } from "../../data";
import { isNumber } from "../../util/validator";

import { CategoryContainer } from "../../components/CategoryContainer";
import { AddAnother } from "../../components/AddAnother";
import { TextFieldRHF, SelectRHF } from "../../components/RHFWrappedComponents";

export function TestScores() {
  const { getValues } = useFormContext();

  return (
    <CategoryContainer title="Academic test Scores">
      <AddAnother
        arrayName="academicInfo.testScores"
        defaultValue={{ test: "", score: "" }}
        renderForm={(i) => (
          <>
            <SelectRHF
              name={`academicInfo.testScores.${i}.test`}
              menuItemOptions={testTypeOptions.map((o) => {
                return { value: o };
              })}
              selectLabel="Test Name"
              rules={{
                validate: {
                  ifScoreSet: (v: string): boolean | string => {
                    const score = getValues(
                      `academicInfo.testScores.${i}.score`
                    );
                    if (score === "") {
                      // Score not set so any value in this field is good
                      return true;
                    }

                    return v !== "" ? true : "Test name required";
                  },
                },
              }}
            />

            <TextFieldRHF
              name={`academicInfo.testScores.${i}.score`}
              textFieldLabel="Test Score"
              rules={{
                validate: {
                  ifTestSet: (v: string): boolean | string => {
                    const test = getValues(`academicInfo.testScores.${i}.test`);
                    if (test === "") {
                      // Test not set so any value in this field is good
                      return true;
                    }

                    return v !== "" ? true : "Test score required";
                  },
                  isNumber: isNumber(),
                },
              }}
            />
          </>
        )}
      />
    </CategoryContainer>
  );
}
